<template>
  <component :ref="name" :is="name"></component>
</template>

<script>
export default {
  name: "contractPrint",
  data() {
    return {
      name: "contractPrintName"
    };
  }
};
</script>

<style scoped></style>
